import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="返回顶部"
      className="fixed right-5 bottom-6 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 cursor-pointer hover:bg-accent-600 transition-colors"
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}